import { render } from "./Groups.vue?vue&type=template&id=17121d5e"
import script from "./Groups.vue?vue&type=script&lang=js"
export * from "./Groups.vue?vue&type=script&lang=js"

import "./Groups.vue?vue&type=style&index=0&id=17121d5e&lang=css"

import exportComponent from "D:\\project\\idbrand\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__